<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-13 09:52:31
 * @LastEditTime: 2019-11-15 15:40:35
 * @LastEditors: Please set LastEditors
 -->
<!--  -->
<template>
  <el-dialog
    :visible.sync="ucFormSet.formVisible"
    title="信息"
    style="text-align: left"
    width="300px"
    class="dialogTheme"
    :modal-append-to-body='false'
  >

    <el-form
      label-position="left"
      label-width="70px"
    >

      <el-form-item label="名称">
        <el-input
          v-model="curFolder.name"
          :readonly="!ucFormSet.sourceNameEditable"
        ></el-input>
      </el-form-item>

      <el-form-item style="text-align: right">
        <el-button @click="hideForm">取消</el-button>
        <el-button @click="_save">确定</el-button>
      </el-form-item>

    </el-form>

  </el-dialog>

</template>


<script>
import { UCOperationType } from "../UCComponentJs.js";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs";
import {DateUtility} from "../../../utility/common/DateUtility.js";
import {
  UserCollectFolder,
  UserCollectFolderFilter,
  UserCollectFolders,
  UserCollectFolderFilterResult
} from "../model/UserCollectJs";
import { UCCollectFolderEvents } from "./UCCollectFolderJs";
import { TdtUser } from '../model/TdtUserJs';

export default {
  name: "UCFormCollectFolder",
  data() {
    return {
      ucFormSet: {
        //form窗口的显隐
        formVisible: false,
        sourceNameEditable: false,

        readOnly: false
      },

      operationType: null,

      //原始收藏夹名称
      oriFolderName:null,

      curFolder: new UserCollectFolder()
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init(operatorType, folder) {
      let self = this;
      this.curFolder = folder;

      this.operationType = operatorType;
      if (operatorType === UCOperationType.operation_add) {
        if (!this.curFolder) {
          this.curFolder = new UserCollectFolder();
        }
        
        this.oriFolderName=null;

        this.ucFormSet.sourceNameEditable = true;
      } else if (operatorType === UCOperationType.operation_update) {
        this.ucFormSet.sourceNameEditable = true;
        if(this.curFolder)
        {
          this.oriFolderName=this.curFolder.name;
        }
      }



    },

    off_addSucceed(callback) {
      if (callback) {
        this.$off(
          UCCollectFolderEvents.UCFormCollectFolder_event_addSucceed,
          callback
        );
      }
    },

    on_addSucceed(callback) {
      if (callback) {
        this.$on(
          UCCollectFolderEvents.UCFormCollectFolder_event_addSucceed,
          callback
        );
      }
    },

    off_updateSucceed(callback) {
      if (callback) {
        this.$off(
          UCCollectFolderEvents.UCFormCollectFolder_event_updateSucceed,
          callback
        );
      }
    },

    on_updateSucceed(callback) {
      if (callback) {
        this.$on(
          UCCollectFolderEvents.UCFormCollectFolder_event_updateSucceed,
          callback
        );
      }
    },

    /**
     * 显示form窗体
     */
    showForm() {
      this.ucFormSet.formVisible = true;
    },

    /**
     * 隐藏form窗体
     */
    hideForm() {
      this.ucFormSet.formVisible = false;
    },
    

    _save() {
      let self = this;

      //校验参数输入是否有误
      let checkStatus = self._ucValidityCheck(function(checkStatus) {
        if (checkStatus) {
          self._saveFolder();
        }
      });
    },

    _ucValidityCheck(checkCallback) {
      let checkStatus = false;

      if (this.curFolder.name == null || this.curFolder.name.trim() == "") {
        //提示
        this.$alert("收藏夹名称不允许为空", "提示", {
          confirmButtonText: "确定"
        });

        return false;
      }

      if(this.oriFolderName===this.curFolder.name)
      { 
        //提示
        this.$alert("收藏夹名称未更新", "提示", {
          confirmButtonText: "确定"
        });

        return false;
      }
      


      let self = this;

      let folderFilter = new UserCollectFolderFilter();
      folderFilter.useName = true;
      folderFilter.name = this.curFolder.name;

      let selectUrl = ServiceUrlConfig.platform_collectfolder_selectByFilter;

      UserCollectFolders.selectByFilter(
        folderFilter,
        selectUrl,
        function(response) {
          let filterResult = UserCollectFolderFilterResult.fromJson(response);
          let filterCount = filterResult.filterFolderCount;

          if (filterCount <= 0) {
            checkStatus = true;
          } else {
            if (self.operationType === UCOperationType.operation_add) {
              checkStatus = false;

              //提示
              self.$alert("收藏夹已存在", "提示", {
                confirmButtonText: "确定"
              });
            } else if (
              self.operationType === UCOperationType.operation_update
            ) {
              //查询出来的所有专题
              if (filterCount >= 2) {
                //提示
                self.$alert("收藏夹已存在", "提示", {
                  confirmButtonText: "确定"
                });
                checkStatus = false;
              } else if (filterCount === 1);
              {
                let filterFolder = filterResult.filterFolders.objects[0];
                //如果名称一致
                if (filterFolder.id !== self.curFolder.id) {
                  //提示
                  self.$alert("收藏夹已存在", "提示", {
                    confirmButtonText: "确定"
                  });
                  checkStatus = false;
                } else {
                  checkStatus = true;
                }
              }
            }
          }

          checkCallback(checkStatus);
          return;
        },
        function(error) {}
      );
    },

    _saveFolder() {
      let self = this;

      if (this.operationType === UCOperationType.operation_add) {
        self.curFolder.createTime=DateUtility.getyyyyMMddhhmmss();
        
        if(TdtUser.currentUser)
        {
          self.curFolder.userId=TdtUser.currentUser.name;
        }

        let saveUrl = ServiceUrlConfig.platform_collectfolder_add;
        self.curFolder.create(
          saveUrl,
          function(response) {
            if (response && response.code==="ok") {
              //提示
              self.$message({
                showClose: true,
                type: "info",
                message: "添加成功"
              });
              //form窗体隐藏
              self.ucFormSet.formVisible = false;

              self.$emit(
                UCCollectFolderEvents.UCFormCollectFolder_event_addSucceed,
                self.curFolder
              );
            } else {
              self.$message({
                showClose: true,
                type: "info",
                message: "添加失败"
              });
            }
          },

          function(error) {
            self.$message({
              showClose: true,
              type: "info",
              message: "添加失败"
            });
          }
        );
      } else if (self.operationType === UCOperationType.operation_update) {
        let updateUrl = ServiceUrlConfig.platform_collectfolder_update;

        self.curFolder.update(
          updateUrl,
          function(response) {
            if (response && response.code==="ok") {
              //提示
              self.$message({
                showClose: true,
                type: "info",
                message: "更新成功"
              });
              //form窗体隐藏
              self.ucFormSet.formVisible = false;

              self.$emit(
                UCCollectFolderEvents.UCFormCollectFolder_event_updateSucceed,
                self.curFolder
              );
            } else {
              self.$message({
                showClose: true,
                type: "info",
                message: "更新失败"
              });
            }
          },

          function(error) {
            self.$message({
              showClose: true,
              type: "info",
              message: "更新失败"
            });
          }
        );
      }
    },
    
  }
};
</script>


<style lang="scss" scoped>
.el-form-item {
  margin-top: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
}
</style>